var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340.62 225.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f818aef4-47b6-4fee-a293-a9be2ba22546{fill:none;stroke:#b0b8c3;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.a993ad0f-8aaa-48d8-88cc-c0a75aeaec53{font-size:28.11px;fill:#b0b8c3;font-family:DINAlternate-Bold, DIN Alternate;font-weight:700;letter-spacing:0.2em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b5e5c05b-82f6-4fce-b2df-0f122535e76e",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b1c07069-1b56-4cf8-8504-27acea54e704",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f818aef4-47b6-4fee-a293-a9be2ba22546",
    cx: 224.17,
    cy: 23.08,
    r: 21.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f818aef4-47b6-4fee-a293-a9be2ba22546",
    points: "19.29 145.93 90.01 145.81 90.01 100.97 67.64 100.97 67.64 166.26 103.41 166.47 116.04 107.42 113.25 96.24 118.28 96.24 121.64 79.46 125.15 96.24 130.02 96.24 127.37 106.84 140.23 166.47 167 161.32 166.43 79.32 112.47 23.09 224.57 23.08 169.48 79.31 170.05 161.32 196.06 166.34 196.06 124.07 204.41 115.78 212.6 124.07 212.6 143.8 232.4 143.8 232.4 124.07 257.97 124.07 257.97 89.51 280.39 66.96 280.39 165.98 317.76 166.34"
  }), /*#__PURE__*/React.createElement("text", {
    className: "a993ad0f-8aaa-48d8-88cc-c0a75aeaec53",
    transform: "translate(2.32 217.56)"
  }, "SPIRITS IN THE SKY")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.77b1188b904182b5f71b8a33057c45f5.svg";
export { ForwardRef as ReactComponent };